<template>
    <div class="madd">
        <div class="madd__header">
            <img
                class="flag madd__flag"
                :src="resource.country.flag"
                v-if="resource.country"
                v-tippy="resource.country.name"
            />
            <h2
                class="madd__title"
                v-text="resource.companyName ? resource.companyName : resource.projectName"
            />
            <span v-if="resource.urgent" class="pill pill--urgent madd__pill">Urgent</span>
        </div>
        <DataList
            class="madd__datalist"
            :columns="2"
            :items="[
                {
                    title: 'Completed Date',
                    value: resource.completedAt,
                    icon: 'calendar',
                    isSector: false,
                },
                {
                    title: 'Deal Type',
                    value: resource.dealType,
                    icon: 'deal',
                    isSector: false,
                },
                {
                    title: 'Counterpart Company',
                    value: resource.counterpartCompany,
                    icon: 'company',
                    isSector: false,
                },
                {
                    title: 'Transaction Value',
                    value: `${resource.transactionCurrency}${resource.transactionValue}m`,
                    icon: 'value',
                    isSector: false,
                },
            ]"
        />
        <div class="datalist madd__sectors">
            <div class="datalist__item dataitem">
                <dt v-text="'Sector'" class="dataitem__title" />
                <dd class="dataitem__value">
                    <span
                        v-for="sector in resource.sectors"
                        v-text="sector.name"
                        class="sector"
                    />
                </dd>
            </div>
        </div>
        <router-link
            v-if="resource && resource.id"
            :to="{
                name: 'view-madd',
                params : {
                    madd_id: resource.id
                }
            }"
            class="btn btn--outline"
        >
            View MADD
        </router-link>
    </div>
</template>
<script>
import SvgIcon from '@components/SvgIcon';
import DataList from '@components/DataList/List';

export default {
    name: "SectorPostCardMadd",
    components: {
        SvgIcon,
        DataList
    },
    props: {
        resource: {
            type: Object,
            required: true,
        }
    },
}
</script>

<style lang="scss" scoped>
@import '~@/theme/_variables.scss';

.madd {
    border: .1rem solid $border;
    border-radius: .4rem;
    padding: 2rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 1.5rem;

    .madd__header {
        display: flex;
        align-items: center;
        column-gap: 1rem;
        width: 100%;

        .madd__flag {
            flex: 0 0 2.4rem;
            width: 2.4rem;
            position: relative;
            top: -.1rem;
        }

        .madd__title {
            margin-bottom: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            flex: 1 1 auto;
        }

        .madd__pill {

        }
    }

    .madd__datalist {

    }

    .btn {
        align-self: flex-start;
    }
}
</style>

